<template>
    <div class="container">
        <div class="topimg">
            <img
                src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/%E4%BA%A7%E5%93%81%E7%BB%8F%E7%90%86%E9%AB%98%E8%96%AA%E8%AE%AD%E7%BB%83%E8%90%A5.png"
                class="section-content"
            >
            <div class="activityImg" v-if="activity.isShow">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <div class="btn-box1">
            <img
                src="https://s21.lgstatic.com/growth/activity/20220628/1656397928813.png"
                class="section-content"
            >
        </div>
        <img src="https://s20.lgstatic.com/growth/activity/20220628/1656397974540.png" class="section-content">
        <div class="tab_center">
            <div class="sub-title">7大阶段打造你的产品经理核心竞争力</div>
            <div class="content">
                <div class="tabViews">
                    <van-tabs v-model="active">
                        <van-tab v-for="(tab, i) in tabsDetail" :key="i" class="tb" :title="tab.steps">
                            <div class="tabs-title">{{ tab.title }}</div>
                            <div class="tabs-title-line"></div>
                            <div v-for="(detail, j) in tab.details" :key="j" class="tabs-content">
                                <div class="tabs-content-title">{{ detail.title }}</div>
                                <div v-for="(txt, k) in detail.txts" :key="k" class="tabs-content-decs">
                                    <div v-if="detail.txts.length > 1" class="tabs-content-icon"></div>{{ txt }}
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                    <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                </div>
            </div>
            <img
                src="https://s21.lgstatic.com/growth/activity/20210226/1614323648887.png"
                class="btn2"
                @click="JumpFn('领取完整课程安排')"
            >
        </div>
      <img src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/%E4%BA%A7%E5%93%81%E7%BB%8F%E7%90%86%E9%AB%98%E8%96%AA%E8%AE%AD%E7%BB%83%E8%90%A5-H5%E7%AB%AF%E5%A4%87%E4%BB%BD%402x(8).png" class="section-content">
<!--        <img src="https://s20.lgstatic.com/growth/activity/20220628/1656398230518.png" class="section-content">-->
<!--        <img src="https://s21.lgstatic.com/growth/activity/20220628/1656398263262.png" class="section-content">-->
<!--        <img src="https://s21.lgstatic.com/growth/activity/20220628/1656398337162.png" class="section-content">-->

        <div class="section">
          <h2 class="title">往期学员评价（3-5期）</h2>
            <div class="swiper-container current-container2">
                <div class="swiper-wrapper current-wraps">
                    <div
                        v-for="(value,inde) in swiperList2"
                        :key="inde"
                        class="swiper-slide current-box"
                    >
                        <img class="company" :src="value"/>
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>

        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/%E4%BA%A7%E5%93%81%E7%BB%8F%E7%90%86%E9%AB%98%E8%96%AA%E8%AE%AD%E7%BB%83%E8%90%A5-H5%E7%AB%AF%E5%A4%87%E4%BB%BD%402x(1).png">
            <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
            <FooterPoup
                :id="80"
                :isDcsj="false"
            />
        </button>
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
import share from '../../../common/js/share';
import touchFix from '../../../uitl/touchmoveFix';
import activity from '../../../common/activity';
import FooterPoup from '../../../components/FooterPoup/index.vue'

    export default {
        directives: {
            touchFix
        },
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            FooterPoup
        },
        data() {
            return {
                activity:activity,//活动图标
                active:0,
                lazyUrlList:[
                    ""
                ],
                day:'00',
                hour:'00',
                minute:'00',

                swiperList2: [
                    "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/20230531/%E5%AD%A6%E5%91%98%E5%8D%A1%E7%89%87-1%402x(1).png",
                    "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/20230531/%E5%AD%A6%E5%91%98%E5%8D%A1%E7%89%87-1%402x(2).png",
                    "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/20230531/%E5%AD%A6%E5%91%98%E5%8D%A1%E7%89%87-1%402x(3).png",
                    "https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/pm_enhancment_mobile/20230531/%E5%AD%A6%E5%91%98%E5%8D%A1%E7%89%87-1%402x.png",
                ],
                tabsDetail: [
                    {
                        steps: "阶段一",
                        title: "用户体系篇",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '具备企业级用户体系的建立思路',
                                    '掌握用户标签体系与用户分层模型的设计与使用',
                                    '培养属干产品经理自身的用户体系--“用户感”',
                                ]
                            },
                            {
                                title: '构建用户体系，找准产品经理必备的“用户感”',
                                txts: [
                                    '产品经理基本功:读懂用户',
                                    '做好用户研究的关键逻辑',
                                    '构建用户体系，获得“用户感”天赋',
                                ]
                            },
                            {
                                title: '从“找到”到“找准”，精确用户画像的方法与思',
                                txts: [
                                    '不同产品的用户画像差异化分析',
                                    '重构产品目标用户的用户画像',
                                    '精准提炼用户标签的五个步骤',
                                ]
                            },
                            {
                                title: '用户体系的积木--用户标签体系',
                                txts: [
                                    '解析:明星产品的用户标签系统',
                                    '重构产品目标用户的用户画像',
                                    '精准提炼用户标签的五个步骤',
                                ]
                            },
                            {
                                title: '从“找到”到“找准”，精确用户画像的方法与思',
                                txts: [
                                    '不同产品的用户画像差异化分析',
                                    '重构产品目标用户的用户画像',
                                    '精准提炼用户标签的五个步骤',
                                ]
                            },
                            {
                                title: '从“找到”到“找准”，精确用户画像的方法与思',
                                txts: [
                                    '不同产品的用户画像差异化分析',
                                    '重构产品目标用户的用户画像',
                                    '精准提炼用户标签的五个步骤',
                                ]
                            },
                        ]
                    },
                    {
                        steps: "阶段二",
                        title: "数据指标篇（上）",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '堂握数据分析中最小单位数据指标的构建思路与逻辑',
                                    '掌握整体数据指标体系的构建方法论',
                                    '可结合自身业务进行指标体系的设计与管理',
                                ]
                            },
                            {
                                title: '产品经理的数据分析知识地图',
                                txts: [
                                    '剖析产品经理数据能力进阶路线',
                                    '产品经理的数据分析知识地图'
                                ]
                            },
                            {
                                title: '通过核心数据指标体系，搭建业务运转飞轮',
                                txts: [
                                    '指标体系的3类指标',
                                    '指标体系的2个核心概念',
                                    '指标的8大组成要素',
                                ]
                            },
                            {
                                title: '善用北极星指标，为业务指明方向',
                                txts: [
                                    '拨开迷雾见光明的北极星指标',
                                    '如何基于业务模型确定北极星指标',
                                    '警惕!北极星的对立面:虚荣指标',
                                ]
                            },
                            {
                                title: '产品经理必须掌握的三个核心数据指标',
                                txts: [
                                    '用户注册类指标:“有效用户”应该如何界定?',
                                    '用户活跃指标:隐藏在活跃指标内的陷阱',
                                    '用户留存类指标:如何准确定义业务的留存?',
                                ]
                            },
                            {
                                title: '指标体系设计在业务中的实际应用',
                                txts: [
                                    '如何根据真实需求搭建数据分析体系?',
                                    '如何在现有的数据体系进行迭代与管理?'
                                ]
                            },
                        ]
                    },
                    {
                        steps: "阶段三",
                        title: "数据指标篇（下）",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '掌握多种不同场景下使用的高阶实战数据分析方法论'
                                ]
                            },
                            {
                                title: '发现数据中的异常:描述性统计',
                                txts: [
                                    '描述性统计的概念和适用场景',
                                    '用“中位数和平均数”来分析指标的分布',
                                    '用“方差和标准差”来分析指标的风险',
                                    '用“箱线图”来找出指标的异常数据'
                                ]
                            },
                            {
                                title: '分析产品中的问题:推断分析法',
                                txts: [
                                    '推断分析的概念和适用场景',
                                    '用“参数估计”从少量样本中推断整体效果',
                                    '用“假设检验”来分析A/B测试的效果',
                                ]
                            },
                            {
                                title: '发现用户行为异常:漏斗分析法',
                                txts: [
                                    '解析漏斗分析的核心概念',
                                    '漏斗分析的缺点解析和改进思考',
                                    '用漏斗分析发现用户路径与异常',
                                    '用“用户路径模型”来优化复杂产品业务常',
                                    '案例:某明星产品的全链路漏斗体系',
                                ]
                            }
                        ]
                    },
                    {
                        steps: "阶段四",
                        title: "数据分析工具篇",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '能够根据工作中具体场景选择合适的方法进行应用，并获得有效结论'
                                ]
                            },
                            {
                                title: '寻找指标变化原因:多维分析法',
                                txts: [
                                    '多维分析的概念和适用场景',
                                    '用“口径”来分析指标变化的原因',
                                    '用“维度”来分析指标变化的原因'
                                ]
                            },
                            {
                                title: '定量判断问题归因:相关性分析法',
                                txts: [
                                    '相关性分析的概念和适用场景',
                                    '相关性分析的使用流程和案例拆解',
                                    '扩展:连续性、二元性、离散性的相关性分析法',
                                ]
                            },
                            {
                                title: '分析产品运营效果:方差分析法',
                                txts: [
                                    '方差分析的概念和适用场景',
                                    '方差分析的使用流程和三种分析方法'
                                ]
                            },
                            {
                                title: '预测未来数据走势:趋势预测法',
                                txts: [
                                    '趋势预测的概念和适用场景',
                                    '基于时间序列进行趋势预测',
                                    '基于回归分析进行趋势预测'
                                ]
                            }
                        ]
                    },
                    {
                        steps: "阶段五",
                        title: "商业变现篇",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '认识缔造自身产品商业价值的商业化思维',
                                    '可以通过课程中的方法论，围绕产品的整个生命周期。进行有效的商业化分析与策略制定',
                                ]
                            },
                            {
                                title: '产品的终极目的:挖掘商业价值',
                                txts: [
                                    '是什么缔造了产品的商业价值?',
                                    '优秀产品经理才具备的商业化思维'
                                ]
                            },
                            {
                                title: '点燃业务商业价值的”发动机“',
                                txts: [
                                    '承载产品商业价值的关键图谱——商业画布',
                                    '探索隐藏着商业画布中的最佳商业模式',
                                    '引燃商业模式的精准驱动点',
                                ]
                            },
                            {
                                title: '构建可持续保持收入增长模型',
                                txts: [
                                    '北极星指标引导下的可持续收入增长',
                                    '成长期: 如何基于收入指标保持业务增长？',
                                    '成熟期: 如何通过ROI保持业务增长？',
                                    '拓展：如何进行产品定价？'
                                ]
                            },
                            {
                                title: '带你找到业务最佳第二曲线',
                                txts: [
                                    '增长新引擎——产品的第二曲线',
                                    '通过商业画布寻找最佳的第二曲线',
                                    '第二曲线的可行性判断与分析',
                                    '双曲线共存下的业务增长道路'
                                ]
                            },
                            {
                                title: '广告业务模式解析与思考',
                                txts: [
                                    '中美互联网广告图谱对比',
                                    '广告模式——供需关系分析',
                                    '广告模式——盈利关系分析',
                                    '大型媒体平台的广告业务模型是怎样的？',
                                    '一个APP如何从0开始推动广告变现？'
                                ]
                            }
                        ]
                    },
                    {
                        steps: "阶段六",
                        title: "产品运营篇",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '深刻认识产品运营在产品经理能力与工作中的必要性与关键性',
                                    '结合课程中方法论，以提升产品价值为目的，指导与配合产品运营的工作',
                                    '有能力围绕自身工作场景。将运营工作标准化与产品化具备操盘重大运营项目的实践能力',
                                ]
                            },
                            {
                                title: '产品总监眼中的产品运营值',
                                txts: [
                                    '产品总监要懂产品运营的哪些领域?',
                                    '产品运营与产品经理有啥区别?'
                                ]
                            },
                            {
                                title: '打造“产品-运营”的双轮驱动模式',
                                txts: [
                                    '为什么是“产品-运营”双轮驱动?',
                                    '导入期:如何建立快速响应机制?',
                                    '成长期:建立运产研一条龙跨团队沟通机制',
                                    '成熟期:双轮驱动下的需求协同管理',
                                ]
                            },
                            {
                                title: '提升产品价值的公式与实际应用',
                                txts: [
                                    '产品价值核心公式:使用价值+交易价值',
                                    '提升使用价值:建设产品体系提升产品',
                                    '提升交易价值:如何产出产品解决方案',
                                    '建立产品品牌，全面提升产品价值'
                                ]
                            },
                            {
                                title: '相倚为强，了解运营工作标准化流程',
                                txts: [
                                    '产品运营利器一标准化SOP',
                                    '标准，高效，可执行的SOP如何建立?',
                                    '标准的SOP中，如何管理并组织各部门分工合作',
                                    '随时变化的业务节奏，SOP 该如何执行?',
                                    '案例:从电商选品案例带来的标准化思考'
                                ]
                            },
                            {
                                title: '业务运营的产品化，赋能业务新动力',
                                txts: [
                                    '产品化路径上:通用运营-垂直运营-精细化运营',
                                    '产品化路径下:人工-半人工半系统-系统',
                                    '基于 RFM 模型的运营工作产品化道路',
                                    '案例:美团补贴活动产品化拆解',
                                    '拓展:典型的活动模式模版应用'
                                ]
                            },
                            {
                                title: '实战:重大运营项目实战全演练',
                                txts: [
                                    '实战拆解:重大运营项目全流程',
                                    '产品在操盘重大运营项目中的绝对职责',
                                    '案例:淘宝双十一、新世相丢书复盘',
                                    '案例:美团logo升级复盘(单项业务向平台型转移)'
                                ]
                            }
                        ]
                    },
                    {
                        steps: "阶段七",
                        title: "B端建模篇",
                        details: [
                            {
                                title: "学习目标",
                                txts: [
                                    '了解产品建模、功能设计',
                                    '流程梳理、业务价值定位',
                                    '如何识别一级域的价值、定义',
                                    '逻辑能力、数据模型',
                                ]
                            },
                            {
                                title: '构建B端产品经理能力模型',
                                txts: [
                                    'B端产品的分类',
                                    'B端产品经理的分类',
                                    'B端产品经理的职责范围及价值',
                                    'B端产品的技能树有哪些（广度）',
                                    'B端产品的增值能力模型（深度）'
                                ]
                            },
                            {
                                title: '打造B端产品经理的高精成长路线',
                                txts: [
                                    '百万年薪的B端产品经理的学习成长之路',
                                    '不同背景的B端产品经理的破局进阶之路',
                                    '学会如何提炼B端产品的底层逻辑，找到业务的最核心痛点',
                                    '结构化思维：如何让你的产品思维条理清晰？',
                                ]
                            },
                            {
                                title: '高效梳理产品价值链，精准定位产品',
                                txts: [
                                    '看零售行业顶级访谈案例，学习业务访谈的窍门',
                                    'B端产品的老大难：如何梳理业务价值、产品价值',
                                    '3个关键维度精准确认产品定位',
                                    '案例解读：一线快消品行业公司的业务价值链梳理',
                                    '以一个订单实例来看下产品建模的价值和意义'
                                ]
                            },
                            {
                                title: '掌握产品建模流程，提升产品能力',
                                txts: [
                                    '3种维度的聚类，掌握抽象产品架构的方法',
                                    '两个方法学会把业务流程分解成产品语言',
                                    '学会如何找到产品服务的主体，减少产品建模的耦合性',
                                    '2个方法鉴别产品系统的边界是否合理',
                                    '手把手教你产品子功能模块如何建模',
                                    '实例解读：大型零售公司产品建模过程演示'
                                ]
                            },
                            {
                                title: '做可闭环可落地的产品人',
                                txts: [
                                    '掌握功能模型三要素，保证产品设计完整闭环',
                                    '常见SAAS中台的原子模块能力图谱',
                                    '学会业务场景还原方法，判断设计合理性及完善性',
                                    '0-1阶段，关注产品核心落脚点',
                                    '中台构建阶段，加强产品能力的复用'
                                ]
                            }
                        ]
                    },
                ],
                addressIdsMap: {
                    "领取完整课程安排": "i1txz",
                    "名额有限立即抢占": "j1ty1"
                }
            };
        },
        mounted() {
            setTimeout(()=>{
                // this.eduPlatTrack('WebView', { page_id: '1rz5'});
                this.platTrack('h5pv', {
                    page_id: '1rz5',
                })
                this.renderSwipers();
            },500)
            this.initShare()
            this.countDown()
        },
        methods: {
            initShare() {
                const shareMsg = {
                    title: '必看！腾讯产品10+职级的能力都有什么？',
                    desc: '行业Top级专家，带你构建产品经理的终极能力',
                    imgUrl: 'https://s21.lgstatic.com/growth/activity/20210301/1614579475411.png'
                };
                share.init(shareMsg);
            },
            renderSwipers() {
                let that = this;
                let option = {
                    speed: 300,
                    autoplay: 3000,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    slidesPerView: 'auto',
                    onClick(e){
                        that.getSlide(e.realIndex)
                    }
                };
                const swiper = new Swiper('.current-container', option);
                let option2 = {
                    speed: 300,
                    autoplay: 3000,
                    loop: true,
                    autoplayDisableOnInteraction: false,
                    slidesPerView: 'auto',
                    spaceBetween: 10
                };
                const swiper2 = new Swiper('.current-container2', option2);
            },
            countDown() {
                const now = Date.parse(new Date());
                let d = new Date(now).getDate()
                if(d % 2 == 0) {
                    this.day = '00'
                } else {
                    this.day = '01'
                }
                let hr = 23 - new Date(now).getHours();
                let min = 59 - new Date(now).getMinutes();
                // let sec = 59 - new Date(now).getSeconds();
                this.hour = hr > 9 ? hr : '0' + hr;
                this.minute= min > 9 ? min : '0' + min;
                // this.minute = sec > 9 ? sec : '0' + sec;
                const that = this;
                this.timer = setTimeout(function () {
                    that.countDown();
                }, 1000);
            },
            JumpFn(str) {
                // this.eduPlatTrack('WebButtonClick', {
                //     'page_id': '1rz5',
                //     'button_name': '领取详细课程大纲'
                // });
                str && this.platTrackClickFn(str)
                setTimeout(() => {
                    let key = 'f331871ccf91414896e61eacd84d1429';
                    handleJumpUrl(key);
                }, 200)
            },
            platTrackClickFn(name) {
                this.platTrack('h5click', {
                    page_id: '1rz5',
                    address_id: this.addressIdsMap[name]
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.section-content {
    width: 100%;
    display: block;
    font-size: 0;
    margin-top: -1px;
    // background-color: #7B6BFF;
}
.container {
    width: 100%;
    padding-bottom: 140px;
}
.section {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    padding: 50px 0 50px 20px;
    background-image: linear-gradient(180deg, #4C78FF 0%, #7771FF 97%);
    .title{
      color: #fff;
      font-size: 44px;
      margin-bottom: 10px;
    }
    .current-container2 {
        width: 100%;
        height: 684px;
        margin-left: 0;
        .current-wraps {
            width: 357px;
            position: absolute;
            .current-box {
                width:357px !important;
                // margin-left: 20px;
                img {
                    width: 100%;
                }
            }
        }
    }
}
.topimg {
    width: 100%;
    position: relative;
    .activityImg {
        position: absolute;
        z-index: 11;
        top: 0;
        right: 0;
        width: 157px;
        height: 158px;
        img {
            width: 100%;
        }
    }
    .btn1 {
        position: absolute;
        width: 382px;
        height: 88px;
        left: 50%;
        transform: translate(-50%);
        bottom: 25px;
    }
    .timer {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        bottom: 136px;
        width: 411px;
        height: 56px;
        background: #F3F6FF;
        border-radius: 30px;
        font-size: 20px;
        color: #3B466A;
        text-align: center;
        line-height: 56px;
        padding:0 10px;
        font-family: 'SourceHanSansSC-Regular', 'SourceHanSansSC';
        .time {
            color: #7B6BFF;
            font-size: 26px;
            background: rgba(108,103,255,0.13);
            padding: 0px 6px;
            border-radius: 4px;
        }
    }
}
.btn-box1 {
    position: relative;
    width: 100%;
    .btn3 {
        position: absolute;
        bottom: 180px;
        left: 50%;
        transform: translate(-50%);
        width: 550px;
        height: 110px;
        z-index: 9;
        background-color: transparent;
        border: none;
    }
}
.btn-box2 {
    position: relative;
    width: 100%;
    .btn4 {
        position: absolute;
        bottom: 140px;
        left: 50%;
        transform: translate(-50%);
        width: 440px;
        height: 110px;
        z-index: 9;
        background-color: transparent;
        border: none;
    }
}
.footer {
    position: fixed;
    background-color:transparent;
    border: none;
    bottom: -1px;
    z-index: 999;
    width: 100%;
    box-shadow: 0px -12px 12px 0px rgba(156, 157, 185, 0.22);
    .img {
        width: 100%;
        display: block;
    }
    .H5activityIcon {
        position: absolute;
        top: -50px;
        right: 42px;
        width: 209px;
    }
}
.tab_center {
    width: 100%;
    position: relative;
    overflow: hidden;
    background-image: linear-gradient(180deg, #6389FF 14%, rgba(108,101,255,0.16) 100%);
    .tab-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
    .btn2 {
        position: absolute;
        width: 422px;
        height: 88px;
        left: 50%;
        transform: translate(-50%);
        bottom: 40px;
    }
}
.content {
    width: 690px;
    margin: 35px auto 80px;
}
/deep/ .tabViews {
    position: relative;
    width: 690px;
    .tips-tab {
        font-size: 14px;
        color: #666;
        position: absolute;
        bottom: 70px;
        right: 20px;
    }
    .van-tabs__wrap--scrollable .van-tabs__nav {
        background: linear-gradient(192deg, #6389FF 0%, #6C65FF 100%);
    }
    .van-tab {
        width: 150px;
        color: #fff;
        font-size: 26px;
        font-weight: 400;
    }
    .van-tabs--line .van-tabs__wrap {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .van-tabs__line {
        background-color: #fff;
        bottom: 0.5rem;
        height: 4px;
    }
    .tb {
        width: 100%;
        padding-bottom: 120px;
        padding-top: 20px;
        background-color: #fff;
        box-shadow: 2px 2px 10px 0px #DFDFE2;
        border-bottom-left-radius: 16px;
        border-bottom-right-radius: 16px;
        img {
            width: 100%;
            // box-shadow: 2px 2px 10px 0px rgba(223, 223, 226, 0.5);

        }
    }
}
.sub-title {
    position: relative;
    width: 500px;
    height: 36px;
    font-size: 30px;
    font-family: AppleSystemUIFont;
    color: #fff;
    line-height: 36px;
    text-align: center;
    margin: 40px auto 0;
    &2 {
        width: 434px;
        margin-top: 0;
    }
    &::before {
        content: '';
        position: absolute;
        left: -79px;
        top: 13px;
        width: 60px;
        height: 10px;
        background: url('https://s21.lgstatic.com/growth/activity/20220610/1654828795175.png') no-repeat center;
        background-size: 60px 10px;
        z-index: 9;
    }
    &::after {
        content: '';
        position: absolute;
        right: -79px;
        top: 13px;
        width: 60px;
        height: 10px;
        background: url('https://s20.lgstatic.com/growth/activity/20220610/1654828766432.png') no-repeat center;
        background-size: 60px 10px;
        z-index: 9;
    }
}
.tabs-title {
    height: 45px;
    font-size: 30px;
    color: #6469A7;
    letter-spacing: 0;
    text-align: center;
}
.tabs-title-line {
    width: 688px;
    height: 2px;
    opacity: 0.3;
    background: radial-gradient( #6469A7 0%, #FFFFFF 33%);
    margin: 20px auto 0;
}
.tabs-content {
    width: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    .tabs-content-title {
        display: inline-block;
        height: 46px;
        line-height: 46px;
        background-image: linear-gradient(191deg, rgba(99, 137, 255, .1) 7%, rgba(108, 101, 255, .1) 87%);
        border-radius: 23px;
        font-size: 24px;
        color: #6469A7;
        letter-spacing: 0;
        text-align: center;
        padding: 0 32px;
    }
    .tabs-content-decs {
        font-size: 20px;
        color: #6469A7;
        letter-spacing: 0;
        line-height: 28px;
        margin-top: 24px;
    }
    .tabs-content-icon {
        display: inline-block;
        width: 8px;
        height: 8px;
        background: #6469A7;
        border-radius: 50%;
        margin-left: 30px;
        margin-right: 12px;
    }
}
</style>
